import { AppRouteProps } from '@bsm/component'
import React from 'react'
import { GroupCalendarOffDayCreateRoutes } from "./calendar/views/create/GroupCalendarOffDayCreateRoutes";

const GroupInformationContainer = React.lazy(() => import("./information/container/GroupInformationContainer"));
const GroupEmployeeContainer = React.lazy(() => import("./employees/container/GroupEmployeeContainer"));
const GroupCalendarContainer = React.lazy(() => import("./calendar/container/GroupCalendarContainer"));

export const GroupsDetailsViewRoutes: Array<AppRouteProps> = [
    {
        path: "about",
        title: "std_about",
        element: <GroupInformationContainer />,
    },
    {
        path: "employees",
        title: "std_employees",
        element: <GroupEmployeeContainer />,
    },
    {
        path: "calendar",
        title: "std_calendar",
        element: <GroupCalendarContainer id="GroupCalendarContainer" view="dayGridMonth" />,
        children: [...GroupCalendarOffDayCreateRoutes],
    },
];
